{
    const DESKTOP_SCREEN = 1015;
    const cards = $('.js-payment-cards');

    const initPaymentSlider = () => {
      $(window).on('load resize orientationchange', () => {
         if ($(window).width() >= DESKTOP_SCREEN) {
             if (cards.hasClass('slick-initialized')) {
                 cards.slick('unslick');
             }
             return false;
         }
         if (!cards.hasClass('slick-initialized')) {
             return cards.slick({
                 mobileFirst: true,
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 dots: true,
                 arrows: false,
                 infinite: false,
                 rtl: m.about.rtl
             });
         }
      });
    };

    cards && initPaymentSlider();
}